/* eslint-disable */

const print = {
    state: {
        title: '',
        printHeader: [],
        printData: [],
        printMerge: []
    },
    mutations: {
        SET_PRINT_HEADER: (state, payload) => {
            state.printHeader = payload
            localStorage.removeItem('printHeader')
            localStorage.setItem('printHeader', JSON.stringify(payload))
        },
        SET_PRINT_DATA: (state, payload) => {
            state.printData = payload
            localStorage.removeItem('printData')
            localStorage.setItem('printData', JSON.stringify(payload))
        },
        SET_PRINT_TITLE: (state, title) => {
            state.title = title
            localStorage.removeItem('title')
            localStorage.setItem('title', title)
        },
        SET_PRINT_MERGE: (state, payload) => {
            state.printMerge = payload
            localStorage.removeItem('printMerge')
            localStorage.setItem('printMerge', JSON.stringify(payload))
        },
        REMOVE_PRINTS: state => {
            state.printHeader = []
            state.printData = []
            state.title = ''
            state.printMerge = []
            localStorage.removeItem('printHeader')
            localStorage.removeItem('printData')
            localStorage.removeItem('title')
            localStorage.removeItem('printMerge')
        }
    },
    actions: {}
}

// 传送数据
// this.$store.commit('SET_PRINT_HEADER', data)
// 获取数据
// this.$store.state.print.printHeader

export default print
